module.exports = __webpack_public_path__ + "img/ic_home_star_white_single.3fccd756.svg";